import AuthService from "@/services/AuthService.js";
import axios from "axios";

export const namespaced = true;

export const state = {
  //user: null,
  user: null,
};

export const mutations = {
  SET_USER_DATA(state, userData) {
    state.user = userData;
    localStorage.setItem("user", JSON.stringify(userData));
    console.log(`Bearer ${userData.token}`);
    axios.defaults.headers.common["Authorization"] = `Bearer ${userData.token}`;
  },
  CLEAR_USER_DATA() {
    localStorage.removeItem("user");
    location.reload();
  },
};

export const actions = {
  setUser({ commit }, userData) {
    console.log("in the user store");
    console.log(userData);
    commit("SET_USER_DATA", userData);
  },
  login({ commit }, authCode) {
    console.log(authCode);
    return AuthService.getUser(authCode)
      .then((user) => {
        console.log(user);
        // user.data.admin = false;
        commit("SET_USER_DATA", user.data);
      })
      .catch((error) => {
        throw error;
      });
  },
  logout({ commit }) {
    commit("CLEAR_USER_DATA");
  },
  getUserInfo() {
    console.log(this.user.data);
    return this.user.data;
  },
};

export const getters = {
  userProjects(state) {
    console.log(state.user);
    if (state.user !== null) {
      return state.user.projects;
    } else {
      return [];
    }
  },
  userAdminStatus: (state) => (state.user ? true : true),
  userAdminId: (state) => state.user.user,
  userInfo: (state) => state.user,
};
